import React, { useEffect, useState, } from "react";
import { Box, Button, Grid, Paper, Snackbar, Typography } from "@mui/material";
import { ReactComponent as IllustrazioneScreening } from "../../resources/illustrazioni/Screening.svg";
import { ReactComponent as IllustrazioneFaq } from "../../resources/illustrazioni/Faq.svg";
import { Link, useNavigate } from "react-router-dom";
import { CAMPAGNE, FAQ } from "../../global/urlMapping";
import { generaLog } from "../../functions/utils";
import { AvvisoHome } from "../tools/AvvisoHome";

export const Home = () => {
  const navigate = useNavigate();

  const onClickCampagneAttive = () => {
    navigate(CAMPAGNE);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  //PWA
  const [isInstallAlertOpen, setIsInstallAlertOpen] = useState(false)
  const [deferredPrompt, setDeferredPrompt] = useState();
  useEffect(() => {
    window.addEventListener('beforeinstallprompt', (e) => {
      //generaLog(`'beforeinstallprompt' event was initialized.`,'log');
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      setDeferredPrompt(e);
      if (localStorage.getItem("snackbar") !== "false") {
        // Update UI notify the user they can install the PWA
        setIsInstallAlertOpen(true);
      }
      // Optionally, send analytics event that PWA install promo was shown.
      //generaLog(`'beforeinstallprompt' event was fired.`,'log');
    });
    window.addEventListener('appinstalled', () => {
      // Hide the app-provided install promotion
      setIsInstallAlertOpen(false);
      // Clear the deferredPrompt so it can be garbage collected
      setDeferredPrompt(null);
      // Optionally, send analytics event to indicate successful install
      generaLog('PWA installed', 'log');
    });
  }, [])
  const installApp = async () => {
    // Hide the app provided install promotion
    setIsInstallAlertOpen(false);
    // Show the install prompt
    deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;
    // Optionally, send analytics event with outcome of user choice
    //generaLog(`User response to the install prompt: ${outcome}`,'log');
    // We've used the prompt, and can't use it again, throw it away
    setDeferredPrompt(null);
  }
  //END PWA

  return (
    <>

      <Box
        className="emptyBg"
        sx={{
          flexGrow: 1,
          overflow: 'hidden',
          px: 4,
          py: 4,
          p: 4,
          width: "100%"
        }}>

        <AvvisoHome />

        <Box sx={{ x: 'auto' }}>
          <Grid container wrap="nowrap" spacing={2}>
            <Grid item xs zeroMinWidth>

              <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                <Typography
                  component="h1"
                  sx={{
                    color: "#005397",
                    margin: "auto",
                    textAlign: "center",
                    fontSize: { xs: "25px", md: "40px" },
                    fontWeight: 700,
                  }}
                >
                  Benvenuti nella WEB APP per lo screening della REGIONE LIGURIA
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ my: 4, mx: 'auto', p: 2 }}>
          <Grid container wrap="nowrap" spacing={2}>
            <Grid item> </Grid>
            <Grid item xs zeroMinWidth>
              <Paper className="change-cursor"
                id="clickCampagneAttive"
                elevation={6}
                sx={{
                  minHeight: "150px",
                  borderRadius: "20px",
                  textDecoration: "none !important",
                  display: "flex",
                  width: { xs: "100%", md: "70%", xl: '60%' },
                  padding: "0px",
                  margin: "auto",
                  marginBottom: "42px"
                }}
                onClick={
                  () => { onClickCampagneAttive() }
                }
              >
                <Box
                  sx={{
                    backgroundColor: "transparent",
                    minHeight: "100px",
                    width: "60%",
                    display: "flex",
                    margin: "auto 0",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                  }}
                >
                  <Typography
                    component='h2'
                    sx={{
                      color: "#005397",
                      fontSize: { xs: "20px", md: "30px" },
                      textTransform: "uppercase",
                      fontWeight: 700,
                      textAlign: "left",
                      margin: "auto 20px",
                    }}
                  >
                    Screening
                  </Typography>
                  <Typography
                    sx={{
                      color: "#005397",
                      fontSize: { xs: "16px", md: "23px" },
                      fontWeight: "regular",
                      textAlign: "left",
                      margin: "auto 20px",
                      textTransform: "none",
                    }}
                  >
                    Verifica la disponibilità di screening a te dedicati
                  </Typography>
                </Box>
                <Box
                  sx={{
                    backgroundColor: "transparent",
                    height: "100%",
                    width: "40%",
                    display: "flex",
                    margin: "auto",
                    marginTop: "-50px",
                  }}
                >
                  <IllustrazioneScreening style={{ height: "200px", width: "200px", margin: "auto" }} id="illustrazioneScreening" />
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>


        <Box
          sx={{
            my: 4,
            mx: 'auto',
            p: 2,
          }}
        >
          <Grid container wrap="nowrap" spacing={2}>
            <Grid item> </Grid>
            <Grid item xs zeroMinWidth>
              <Paper
                elevation={6}
                sx={{
                  minHeight: "150px",
                  borderRadius: "20px",
                  textDecoration: "none !important",
                  display: "flex",
                  width: { xs: "100%", md: "70%", xl: '60%' },
                  padding: "0px",
                  margin: "auto",
                  marginBottom: "42px"

                }}
                component={Link}
                to={FAQ}
              >
                <Box
                  sx={{
                    backgroundColor: "transparent",
                    minHeight: "100px",
                    width: "60%",
                    display: "flex",
                    margin: "auto 0",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                  }}
                >
                  <Typography
                    component='h2'
                    sx={{
                      color: "#005397",
                      fontSize: { xs: "20px", md: "30px" },
                      textTransform: "uppercase",
                      fontWeight: 700,
                      textAlign: "left",
                      margin: "auto 20px",
                    }}
                  >
                    Faq
                  </Typography>
                  <Typography
                    sx={{
                      color: "#005397",
                      fontSize: { xs: "16px", md: "23px" },
                      fontWeight: "regular",
                      textAlign: "left",
                      margin: "auto 20px",
                      textTransform: "none",
                    }}
                  >
                    Hai bisogno di aiuto? Consulta le domande poste frequentemente
                  </Typography>
                </Box>
                <Box
                  sx={{
                    backgroundColor: "transparent",
                    height: "100%",
                    width: "40%",
                    display: "flex",
                    margin: "auto",
                    marginTop: "-50px",
                  }}
                >
                  <IllustrazioneFaq style={{ height: "200px", width: "200px", margin: "auto" }} id="illustrazioneFaq" />
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>

      </Box>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={isInstallAlertOpen}
        autoHideDuration={20000}
        onClose={() => setIsInstallAlertOpen(false)}
        message="VUOI INSTALLARE L'APP PRENOTO PREVENGO?"
        sx={{ marginBottom: '20px' }}
        action={
          <>
            <Button color="inherit" size="small" onClick={() => { installApp() }}>
              SI
            </Button>
            <Button color="inherit" size="small" onClick={() => { setIsInstallAlertOpen(false); localStorage.setItem("snackbar", "false"); }}>
              NO
            </Button>
          </>
        }
      />
    </>
  );
};